import { render, staticRenderFns } from "./Calculate.vue?vue&type=template&id=afbda9ec&scoped=true"
import script from "./Calculate.vue?vue&type=script&lang=js"
export * from "./Calculate.vue?vue&type=script&lang=js"
import style0 from "./Calculate.vue?vue&type=style&index=0&id=afbda9ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afbda9ec",
  null
  
)

export default component.exports